module.exports = __webpack_public_path__ + "static/sport/slide2.4fb2f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide2.png
// module id = +gDf
// module chunks = 0